import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  checkUniqueBranchNameAction,
  createMasterDataCurrencyAction,
  getAllMasterDataCurrencyAction,
  getMasterDataCurrencyAction,
  resetBranchError,
  resetBranchFetching,
  resetBranchMessage,
  resetBranchSatusCode,
  resetIsBranchName,
  resetMasterDataCurrencyListTotal,
  resetMasterDataCurrencyListing,
  resetMasterError,
  resetMasterMessage,
  resetMasterSuccess,
  updateMasterDataCurrencyAction,
} from "../../../redux/masterData";
import { RootState } from "../../../redux/rootReducers";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
  RollingLoader,
} from "../../../components/commons";
import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import { Toaster, toast } from "react-hot-toast";
import { CURRENCY_HEADERS } from "../../../constant/tableHeadersConstants/masterDataContants/masterDataCurrencyListConst";
import CurrencyTable from "../../../components/MasterData/CurrencyTables";
import { SearchIcon } from "../../../components/Icon";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import {
  CreateCurrencyDataPayloadType,
  GetAllMasterDataCurrencyPayloadType,
  UpdateCurrencyDataPayloadType,
} from "../../../commonTypes/masterDataTypes";
import { MasterCurrencyListingTypes } from "../../../redux/masterData/masterTypes";
import useDebounce from "../../../customHooks/useDebounce";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type UniqueCurrencyType = {
  token: string | null;
  operation: string | null;
  branchName?: string | null | undefined;
  activity_code?: string;
  currency_name?: string;
  unique_check?: string;
  data_id?: string | null;
  name?: string;
};

type AppProps = {
  history: any;
  masterDataCurrencyListing: [];
  fetching: boolean;
  message: string;
  success: null | number;
  token: null | string;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  masterDataCurrencyListTotal: string | number;
  dispatchResetSession: () => void;
  dispatchResetMasterDataCurrencyListTotal: () => void;
  dispatchResetMasterDataCurrencyListing: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetCurrencyStatusCode: () => void;
  dispatchResetCurrencyError: () => void;
  dispatchResetCurrencyMessage: () => void;
  dispatchResetIsCurrencyName: () => void;
  dispatchResetCurrencyFetching: () => void;
  currencyFetching: boolean;
  isCurrencyName: null | number;
  currencyMessage: string | null;
  dispatchCheckUnqiueCurrencyName: (data: any) => void;
  dispatchAddMasterCurrency: (data: CreateCurrencyDataPayloadType) => void;
  dispatchGetMasterDataCurrency: (data: string | null) => void;
  dispatchUpdateMasterDataCurrency: (
    data: UpdateCurrencyDataPayloadType
  ) => void;
  dispatchGetAllMasterDataCurrencyList: (
    data: GetAllMasterDataCurrencyPayloadType
  ) => void;
};
const Currency = ({
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  masterDataCurrencyListing,
  masterDataCurrencyListTotal,
  currencyFetching,
  isCurrencyName,
  currencyMessage,
  dispatchResetSession,
  dispatchResetMasterDataCurrencyListTotal,
  dispatchResetMasterSuccess,
  dispatchResetMasterDataCurrencyListing,
  dispatchResetMasterMessage,
  dispatchResetMasterError,
  dispatchAddMasterCurrency,
  dispatchGetMasterDataCurrency,
  dispatchResetCurrencyStatusCode,
  dispatchResetCurrencyError,
  dispatchResetCurrencyMessage,
  dispatchResetIsCurrencyName,
  dispatchResetCurrencyFetching,
  dispatchCheckUnqiueCurrencyName,
  dispatchUpdateMasterDataCurrency,
  dispatchGetAllMasterDataCurrencyList,
}: AppProps) => {
  const [currencyError, setCurrencyError] = useState<string>("");
  const [id, setId] = useState<string | null | undefined>(null);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [data, setData] = useState<[] | MasterCurrencyListingTypes[]>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [currencyName, setCurrencyName] = useState<string>("");
  const [currencySign, setCurrencySign] = useState<string>("");
  const [currencyShortForm, setCurrencyShortForm] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [showAddCurrencyModal, setShowAddCurrencyModal] =
    useState<boolean>(false);
  const [uniqueCurrency, setUniqueCurrency] = useState<UniqueCurrencyType>({
    token,
    operation: "",
    activity_code: "",
    unique_check: "",
    currency_name: "",
    data_id: "",
    name: "",
  });
    //====================User Management=============================
    const [isAddCurrencyPresent, setIsAddCurrencyPresent] =
    useMenuCheck();
  const [isEditCurrencyPresent, setIsEditCurrencyPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetMasterDataCurrencyListing();
    dispatchResetMasterDataCurrencyListTotal();
    dispatchResetCurrencyStatusCode();
    dispatchResetCurrencyError();
    dispatchResetCurrencyMessage();
    dispatchResetIsCurrencyName();
    dispatchResetCurrencyFetching();
    setIsAddCurrencyPresent("Add Currency", "menu");
    setIsEditCurrencyPresent("Edit Currency", "menu")
  }, []);

  useEffect(() => {
    if (masterDataCurrencyListing?.length === 0) {
      setData(masterDataCurrencyListing);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...masterDataCurrencyListing]);
    } else {
      setData(masterDataCurrencyListing);
    }
  }, [masterDataCurrencyListing]);

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterMessage();
    if (token) {
      let finalData: GetAllMasterDataCurrencyPayloadType = {
        token,
        limit,
        offset,
        search_term: searchData,
      };

      if (offset < +masterDataCurrencyListTotal) {
        dispatchGetAllMasterDataCurrencyList(finalData);
      } else if (offset === 0 && masterDataCurrencyListTotal === "") {
        dispatchGetAllMasterDataCurrencyList(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (!showAddCurrencyModal) {
      setIsEdit(false);
    }
  }, [showAddCurrencyModal]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData();
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  const toggleAddCurrencyModal = () => {
    setCurrencyError("")
    if (!showAddCurrencyModal) {
      handleResetData();
    }
    setShowAddCurrencyModal(!showAddCurrencyModal);
    
  };
  const handleCurrencyNameChange = (e: any) => {
    let currencyNameInput = e.target.value;
    if (isEdit) {
      const finalData = {
        token,
        operation: "update",
        name: currencyNameInput.trim(),
        data_id: id,
        unique_check: "currency",
      };
      dispatchResetCurrencyStatusCode();
      dispatchResetCurrencyError();
      dispatchResetCurrencyMessage();
      dispatchResetIsCurrencyName();
      dispatchResetCurrencyFetching();
      setUniqueCurrency(finalData);
    } else {
      const finalData = {
        token,
        operation: "add",
        name: currencyNameInput.trim(),
        unique_check: "currency",
      };
      dispatchResetCurrencyStatusCode();
      dispatchResetCurrencyError();
      dispatchResetCurrencyMessage();
      dispatchResetIsCurrencyName();
      dispatchResetCurrencyFetching();
      setUniqueCurrency(finalData);
    }
    setCurrencyName(e.target.value);
    if (currencyError) {
      setCurrencyError("");
    }
  };

  const handleCurrencySignChange = (e: any) => {
    setCurrencySign(e.target.value);
    if (currencyError) {
      setCurrencyError("");
    }
  };
  const handleCurrencyShortFormChange = (e: any) => {
    setCurrencyShortForm(e.target.value);
    if (currencyError) {
      setCurrencyError("");
    }
  };

  useDebounce(
    () => {
      if (currencyName) {
        dispatchCheckUnqiueCurrencyName(uniqueCurrency);
      }
    },
    500,
    [uniqueCurrency]
  );
  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-master-currency":
        return setSuccessMessage("Currency has been added successfully!");
      case "update-master-currency":
        return setSuccessMessage("Currency Data Updated Successfully!");
      default:
        return setSuccessMessage("");
    }
  };

  const fetchNewData = () => {
    if (token) {
      let finalData = {
        token,
        search_term: searchData,
        limit,
        offset,
      };
      if (offset === 0) {
        // setOffset(0)
        dispatchGetAllMasterDataCurrencyList(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleEditMasterCurrency = (data: MasterCurrencyListingTypes) => {
    dispatchResetCurrencyStatusCode();
    dispatchResetCurrencyError();
    dispatchResetCurrencyMessage();
    dispatchResetIsCurrencyName();
    dispatchResetCurrencyFetching();
    setIsEdit(true);
    setShowAddCurrencyModal(true);
    setCurrencyName(data?.currency_name);
    setCurrencySign(data?.currency_sign);
    setCurrencyShortForm(data?.currency_short_form);
    setIsEdit(true);
    setId(data?._id);
    setCurrencyError("")
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
        currency_name: currencyName,
      };
      dispatchGetAllMasterDataCurrencyList(finalData);
    }
  };

  const handleAddCurrency = (e: MasterCurrencyListingTypes) => {
    dispatchResetCurrencyStatusCode();
    dispatchResetCurrencyError();
    dispatchResetCurrencyMessage();
    dispatchResetIsCurrencyName();
    dispatchResetCurrencyFetching();
    if (
      currencyName?.trim()?.length > 0 &&
      !currencyMessage?.includes("already exists")
    ) {
      if (isEdit) {
        let updateData: UpdateCurrencyDataPayloadType = {
          currency_name: currencyName,
          currency_sign: currencySign,
          currency_short_form: currencyShortForm,
          token: token,
          _id: id,
        };
        dispatchUpdateMasterDataCurrency(updateData);
        handleSuccessMessage("update-master-currency");
      } else {
        let finalAddData = {
          currency_name: currencyName,
          currency_sign: currencySign,
          currency_short_form: currencyShortForm,
          token: token,
        };
        dispatchAddMasterCurrency(finalAddData);
        handleSuccessMessage("created-master-currency");
        setSearchData("");
      }
    } else {
      setCurrencyError("Currency Name is required!");
    }
  };
  const handleResetData = () => {
    setCurrencyName("");
    setCurrencySign("");
    setCurrencyShortForm("");
  };

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +masterDataCurrencyListTotal &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (masterDataCurrencyListing?.length > 0) {
          if (!fetching && offset < +masterDataCurrencyListTotal) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [masterDataCurrencyListing]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
      else{

      }
    }

    if (success === 1 && message == "Currency has been added successfully!") {
         toast.success(successMessage, {
            duration: 2000,
        });
        dispatchResetMasterSuccess();
        dispatchResetMasterMessage();

      if (token) {
        if (offset === 0) {
          let finalData = { token, offset, limit ,  search_term: searchData,};
          dispatchGetAllMasterDataCurrencyList(finalData);
        } 
      }

    }
    if (success === 1 && message == "Currency has been updated successfully!") {
      let finalData = { token, offset: 0, limit };
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        if (offset === 0) {
          let finalData = { token, offset, limit ,  search_term: searchData, };
          dispatchGetAllMasterDataCurrencyList(finalData);
        } 
      }
    }

    return false;
  };

  useEffect(() => {
      if (offset === 0) {
          window.scrollTo(0, 0);
          } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Currency" />
      </div>
      <div className="col-md-6 text-right">
        {!!masterDataCurrencyListing?.length &&  isAddCurrencyPresent &&(
          <button onClick={toggleAddCurrencyModal} className="btn btn-primary">
            + Add Currency
          </button>
        )}
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading"> Currency List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${masterDataCurrencyListTotal ? masterDataCurrencyListTotal : 0
                } entries found`}</div>}

            </div>
            <div
              className="text-right d-flex flex-row col-lg-8"
              style={{ justifyContent: "flex-end" }}
            >
              <div className="mr-2 w-auto position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "13px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
            </div>
          </div>

          <>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : masterDataCurrencyListing?.length > 0 ? (
              <div className="jobsType">
                    <table className="table thead-light table-bordered">
                      <thead className="text-left sticky-table-header">
                        <TableHeader tableHeader={CURRENCY_HEADERS} />
                      </thead>
                      <tbody>
                        <CurrencyTable
                          data={data}
                          tableHeaders={CURRENCY_HEADERS}
                          handleEditMasterCurrency={handleEditMasterCurrency}
                          isEditCurrencyPresent={isEditCurrencyPresent}
                        />
                        <div style={{ display: fetching ? "none" : "inline" }}>
                          <ScrollToTop />
                        </div>
                        {fetching && offset > 0 && (
                          <div>{<InfiniteLoader />}</div>
                        )}
                      </tbody>
                    </table>
                  </div>
            ) : (
              <>
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Currency !"
                    text={isAddCurrencyPresent?"Add a Currency data to see it here in the list!":""}
                    imageWidth="30%"
                    showAddButton={isAddCurrencyPresent}
                    buttonTitle="+ Add Currency"
                    onButtonClick={toggleAddCurrencyModal}
                  />
                )}
              </>
            )}
          </>
        </div>
      </div>
      {showAddCurrencyModal ? (
        <Modal isOpen={showAddCurrencyModal} toggle={toggleAddCurrencyModal}>
          <ModalHeader className="pt-4 pl-4">
            {`${isEdit ? "Edit" : "Add"} Currency`}
          </ModalHeader>
          <ModalBody className="pl-4 pr-4">
            <form>
              <div className="form-group mt-3">
                <div>
                  <label
                    htmlFor="foldername"
                    className={currencyName ? "active" : ""}
                  >
                    Enter Currency Name<span className="color-red">*</span>
                  </label>
                  <div className="d-flex flex-row position-relative">
                    <input
                      type="text"
                      className={`form-control ${
                        !!currencyError ? "error-border" : null
                      }`}
                      name="text"
                      value={currencyName}
                      autoFocus
                      onChange={(e) => handleCurrencyNameChange(e)}
                      maxLength={60}
                      onKeyPress={(e: any) =>
                        e.key === "Enter" ? handleAddCurrency(e) : null
                      }
                    />
                    {currencyFetching && <RollingLoader />}
                  </div>
                  {isCurrencyName === 1 &&
                  currencyName?.trim().length &&
                  currencyMessage?.includes("already exists") ? (
                    <small className="text-danger">
                      Currency Name is already in use!
                    </small>
                  ) : (
                    ""
                  )}

                  {!!currencyError && currencyName?.trim().length == 0 && (
                    <small className="text-danger">{currencyError}</small>
                  )}
                </div>
                <span className="input-length">
                  {returnInputFieldLength(currencyName?.length, 60)}
                </span>
              </div>
              <div className="form-group mt-3">
                <div>
                  <label htmlFor="status">Currency Sign<span className="color-red">*</span></label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={currencySign}
                    autoFocus
                    onChange={(e) => handleCurrencySignChange(e)}
                    maxLength={60}
                    onKeyPress={(e: any) =>
                      e.key === "Enter" ? handleAddCurrency(e) : null
                    }
                  />
                </div>
              </div>
              <div className="form-group mt-3">
                <div>
                  <label htmlFor="status">Currency Short Form<span className="color-red">*</span></label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={currencyShortForm}
                    autoFocus
                    onChange={(e) => handleCurrencyShortFormChange(e)}
                    maxLength={60}
                    onKeyPress={(e: any) =>
                      e.key === "Enter" ? handleAddCurrency(e) : null
                    }
                  />
                </div>
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <span className="pointer" onClick={toggleAddCurrencyModal}>
              Cancel
            </span>
            <Button
              color="primary ml-3"
              onClick={(e: any) => {
                handleAddCurrency(e);
                if(currencyName?.trim()?.length){

                    toggleAddCurrencyModal();
                }
              }}
              disabled={
                !currencyName ||!currencyShortForm||!currencySign||
                (isCurrencyName === 1 &&
                  currencyMessage?.includes("already exists"))
              }
            >
              {isEdit ? "Update Currency" : "Add Currency"}
            </Button>
          </ModalFooter>
        </Modal>
      ) : (
        ""
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  masterDataCurrencyListing: state.masterData.masterDataCurrencyListing,
  masterDataCurrencyListTotal: state.masterData.masterDataCurrencyListTotal,
  success: state.masterData.success,
  message: state.masterData.message,
  currencyMessage: state.masterData.branchMessage,
  currencyFetching: state.masterData.branchFetching,
  isCurrencyName: state.masterData.isBranchName,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterDataCurrencyListing: () =>
    dispatch(resetMasterDataCurrencyListing()),
  dispatchResetMasterDataCurrencyListTotal: () =>
    dispatch(resetMasterDataCurrencyListTotal()),
  dispatchGetAllMasterDataCurrencyList: (
    data: GetAllMasterDataCurrencyPayloadType
  ) => dispatch(getAllMasterDataCurrencyAction(data)),
  dispatchAddMasterCurrency: (data: CreateCurrencyDataPayloadType) =>
    dispatch(createMasterDataCurrencyAction(data)),
  dispatchGetMasterDataCurrency: (data: string | null) =>
    dispatch(getMasterDataCurrencyAction(data)),
  dispatchUpdateMasterDataCurrency: (data: UpdateCurrencyDataPayloadType) => {
    dispatch(updateMasterDataCurrencyAction(data));
  },
  dispatchResetCurrencyStatusCode: () => dispatch(resetBranchSatusCode()),
  dispatchResetCurrencyError: () => dispatch(resetBranchError()),
  dispatchResetCurrencyMessage: () => dispatch(resetBranchMessage()),
  dispatchResetIsCurrencyName: () => dispatch(resetIsBranchName()),
  dispatchResetCurrencyFetching: () => dispatch(resetBranchFetching()),
  dispatchCheckUnqiueCurrencyName: (data: any) =>
    dispatch(checkUniqueBranchNameAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Currency);
